import axios, { AxiosError } from 'axios';
import { Api } from '../axiosApi';

interface DataRNfe {
  serie: number;
  nfe: number;
  dhemi: string;
  nome: string;
  cpf: string;
  cfop: string;
  vnfe: number;
  vprod?: number; // soma dos itens (sem impostos)
  finalidade: string;
  status: string;
}


interface ErrorResponse {
  errors: {
    default: string;
  };
}
const RNfe = async (
  tipo: string,
  datainicial: string,
  datafinal: string,
  status: string
): Promise<DataRNfe[] | Error> => {

  try {

    const urlRelativa =
      `/relatorionfe?tipo=${tipo}&datainicial=${datainicial}&datafinal=${datafinal},&status=${status}`;

    const { data } = await Api.get<DataRNfe[]>(urlRelativa);

    if (data) {
      return data;
    }

    return new Error('Erro ao consultar o relatório de vendas.');

  } catch (error) {

    if (axios.isAxiosError(error)) {

      const axiosError = error as AxiosError<ErrorResponse>;

      if (axiosError.response) {

        const errorMessage =
          axiosError.response.data.errors?.default || 'Erro desconhecido';

        return new Error(errorMessage);

      } else if (axiosError.request) {

        return new Error('Nenhuma resposta do servidor');

      } else {

        return new Error(axiosError.message);

      }

    }

    return new Error('Erro inesperado');
  }
};

const RNfCe = async (
  tipo: string,
  datainicial: string,
  datafinal: string,
  status: string

): Promise<DataRNfe[] | Error> => {

  try {

    const urlRelativa =
      `/relatorionfce?tipo=${tipo}&datainicial=${datainicial}&datafinal=${datafinal}&status=${status}`;

    const { data } = await Api.get<DataRNfe[]>(urlRelativa);

    if (data) {
      return data;
    }

    return new Error('Erro ao consultar o relatório de vendas.');

  } catch (error) {

    if (axios.isAxiosError(error)) {

      const axiosError = error as AxiosError<ErrorResponse>;

      if (axiosError.response) {

        const errorMessage =
          axiosError.response.data.errors?.default || 'Erro desconhecido';

        return new Error(errorMessage);

      } else if (axiosError.request) {

        return new Error('Nenhuma resposta do servidor');

      } else {

        return new Error(axiosError.message);

      }

    }

    return new Error('Erro inesperado');
  }
};


export interface DataRProdutoFiscal {
  descricao: string;
  codinterno: string | null;
  un: string;
  ean: string | null;
  eanentrada: string | null;
  ncm: string | null;
  cest: string | null;
  cfop: number | null;
  origem: number | null;
  cst: number | null;
  cstipi: string | null;
  cstcofins: string | null;
  cstpis: string | null;
  icms: number | null;
  picms: number | null;
  pcofins: number | null;
  ppis: number | null;
  pipi: number | null;
  descanp: string | null;
  cprodanp: string | null;
  quan: number;
}

// Todo produto com estoque > 0, com descrição/EAN e todas as configurações
// fiscais (CFOP, NCM, CEST, origem, CST/PIS/COFINS/IPI, ANP) — sem filtros,
// backend (`GET /rprodutosfiscal`) já devolve só o que tem estoque.
const RProdutosFiscal = async (): Promise<DataRProdutoFiscal[] | Error> => {

  try {

    const { data } = await Api.get<DataRProdutoFiscal[]>('/rprodutosfiscal');

    if (data) {
      return data;
    }

    return new Error('Erro ao consultar o relatório fiscal de produtos.');

  } catch (error) {

    if (axios.isAxiosError(error)) {

      const axiosError = error as AxiosError<ErrorResponse>;

      if (axiosError.response) {

        const errorMessage =
          axiosError.response.data.errors?.default || 'Erro desconhecido';

        return new Error(errorMessage);

      } else if (axiosError.request) {

        return new Error('Nenhuma resposta do servidor');

      } else {

        return new Error(axiosError.message);

      }

    }

    return new Error('Erro inesperado');
  }
};

export const RelatorioFiscalService = {
  RNfe,
  RNfCe,
  RProdutosFiscal,
};